import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { translate } from 'i18n/jhipster-language';
import moment from 'moment';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
import { cmsHttp } from 'shared/api/mfe-axios';
import { APP_LOCAL_DATETIME_FORMAT } from 'app/config/constants';
const formatDt = (v) => v ? moment(v).format(APP_LOCAL_DATETIME_FORMAT) : '';
const formatAmount = (amount, currency) => amount != null ? `${amount.toLocaleString()} ${currency ?? ''}` : '';
function CardStatementTab({ cardId }) {
    const [statement, setStatement] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!cardId)
            return;
        const fetchStatement = async () => {
            try {
                setLoading(true);
                const response = await cmsHttp().get(`api/${cardId}/mini-statement`);
                setStatement(response.data);
            }
            catch (error) {
                console.error('Mini statement error:', error);
                setStatement(null);
            }
            finally {
                setLoading(false);
            }
        };
        fetchStatement();
    }, [cardId]);
    if (loading) {
        return _jsx(Skeleton, { height: "6rem" });
    }
    if (!statement) {
        return (_jsx("div", { className: "p-text-center p-mt-3", children: translate('form.noRecordsFound') }));
    }
    return (_jsx("div", { className: "p-mt-3 mt-4", children: _jsx(PRow, { children: _jsx(PCol, { col: "12", children: _jsxs(DataTable, { value: statement.recentTransactions ?? [], paginator: true, rows: 10, className: 'mt-4', emptyMessage: translate('form.noRecordsFound'), responsiveLayout: "scroll", children: [_jsx(Column, { field: "transactionReference", header: translate('form.transactionReference') }), _jsx(Column, { field: "eventType", header: translate('form.eventType') }), _jsx(Column, { field: "channelType", header: translate('form.channelType') }), _jsx(Column, { header: translate('form.amount'), body: (row) => formatAmount(row.amount, row.currencyCode) }), _jsx(Column, { field: "currencyCode", header: translate('form.currency') }), _jsx(Column, { header: translate('form.eventTime'), body: (row) => formatDt(row.eventTime) })] }) }) }) }));
}
export default CardStatementTab;
